import { request, withQuery } from './client';
import type { SupplierInput, SupplierListResponse } from '@kassa/shared';

// Təchizatçılar (KT-108).
export const suppliersApi = {
  suppliers: (p: { q?: string; debt?: string; page?: number; limit?: number }) => request<SupplierListResponse>('GET', withQuery('/api/suppliers', { ...p })),
  supplierCreate: (body: SupplierInput) => request<{ id: string }>('POST', '/api/suppliers', body),
  supplierUpdate: (id: string, body: SupplierInput) => request<{ id: string }>('PATCH', `/api/suppliers/${encodeURIComponent(id)}`, body),
};
